import React, { useEffect, useState } from "react";
import "./income.scss";
import { useDispatch, useSelector } from "react-redux";
import { fetchVehicle } from "../../store/slices/Vehicle/thunk";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import { MdDelete } from "react-icons/md";

import EditIcon from "@mui/icons-material/Edit";
import { deleteIncome, fetchIncomeAndExpenses } from "../../store/slices/thunk";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { IoSearchOutline } from "react-icons/io5";
import ConfirmDialog from "../../components/deleteModal";
import Loader from "../../components/loader";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";
const IncomeAndExpensesList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllIncomeAndExpenses, setAllIncomeAndExpenses] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500; // milliseconds
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllIncomeAndExpenses);


  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true); // Start loader
      try {
        const response = await dispatch(
          fetchIncomeAndExpenses(page, ITEMS_PER_PAGE, search)
        );
        if (response && response?.data?.data?.length > 0 && response.isSuccess) {
          setAllIncomeAndExpenses(response.data.data);
          setTotalCount(response.data.totalCount);
        } else {
          setAllIncomeAndExpenses([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.log(getAllIncomeAndExpenses);
      } finally {
        setIsLoading(false); // Stop loader
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    }
  }, [search, page, dispatch]);


  const gotoEdit = (id: string) => {
    navigate(`/edit-income/${id}`);
  };
  const handleDelete = async (id: string) => {
    const response = await dispatch(deleteIncome(id));
    if (response && response.isSuccess) {
      const updatedIncomeAndExpenses = getAllIncomeAndExpenses.filter(
        (item: any) => item._id !== id
      );
      setAllIncomeAndExpenses(updatedIncomeAndExpenses);
    }
  };
  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await handleDelete(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };
    const navigateToaddicome = () => {
    navigate("/add-income");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="income-list" style={{ flexShrink: 0 }}>
          <div className="d-flex flex-column">
            <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
              Income & Expenses
            </h2>
            <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
              Track financial records and reports
            </p>
          </div>
        <p>
          {" "}
           <button className="px-2 py-2"      onClick={navigateToaddicome} style={{background:"#3b82f6", color:"#fff", borderRadius:"10px", height:"auto", width:"auto", border:"none"}}><AddIcon/>Add New Income</button>
        </p>
      </div>
      <Paper sx={{ padding: 2, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <div className="search-box align-items-baseline justify-content-start" style={{ flexShrink: 0 }}>
            <div className="search-wrapper">
              <IoSearchOutline className="search-icon" />
              <input
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search Income Details Here"
              />
            </div>
          </div>


          <TableContainer sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
          <Table className="table">
            <TableHead className="th">
           <TableRow>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", fontWeight: 500, background: "#F9FAFB", fontSize: "18px" }}
  >
    S.No
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", fontWeight: 500, background: "#F9FAFB", fontSize: "18px" }}
  >
    Vehicle
    <FilterPopover column="vehicle.vehicleName" filterType="text" currentValue={filters["vehicle.vehicleName"] || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", fontWeight: 500, background: "#F9FAFB", fontSize: "18px" }}
  >
    Date
    <FilterPopover column="date" filterType="text" currentValue={filters.date || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", fontWeight: 500, background: "#F9FAFB", fontSize: "18px" }}
  >
    Description
    <FilterPopover column="description" filterType="text" currentValue={filters.description || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", fontWeight: 500, background: "#F9FAFB", fontSize: "18px" }}
  >
    Amount
    <FilterPopover column="amount" filterType="text" currentValue={filters.amount || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", fontWeight: 500, background: "#F9FAFB", fontSize: "18px" }}
  >
    Status
    <FilterPopover column="type" filterType="text" currentValue={filters.type || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", fontWeight: 500, background: "#F9FAFB", fontSize: "18px" }}
  >
    Action
  </TableCell>
</TableRow>

   
            </TableHead>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <Loader />
                </TableCell>
              </TableRow>
            ) : (

              <TableBody >
                {filteredData.map((item: any, index) => (
                  <TableRow key={index}>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>{index + 1}</TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {item.vehicle.vehicleName || "--"}
                    </TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {item.date
                        ? new Date(item.date).toLocaleDateString("en-GB")
                        : "--"}
                    </TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {item.description || "--"}
                    </TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {item.amount || "--"}
                    </TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {/* <Chip
                        label={item.type || "--"}
                        size="small"
                        style={{color:" #991B1B", background:"#FEE2E2"}}
                      /> */}

                      
                 {/* {item.type === "Income" ? (
  <button
    style={{
      color: "#065F46",
      background: "#D1FAE5",
      border: "none",
      borderRadius: "15px",
      height: "25px",
    }}
  >
    Income
  </button>
) : (
  <button
    style={{
      color: "#991B1B",
      background: "#FECACA",
      border: "none",
      borderRadius: "15px",
      height: "25px",
    }}
  >
    Expense
  </button>
)} */}

<button
  style={{
    color: item.type === "Income" ? "#065F46" : "#991B1B",
    background: item.type === "Income" ? "#D1FAE5" : "#FECACA",
    border: "none",
    borderRadius: "15px",
    height: "25px",
  }}
>
  {item.type}
</button>


                    </TableCell>
                    <TableCell className="table-cell">
                      <IconButton >
                        <EditIcon
                          onClick={() => gotoEdit(item._id)}
                          style={{ color: "blue" }}
                        />
                      </IconButton>
                      <IconButton >
                        <MdDelete
                          onClick={() => handleDeleteClick(item._id)}
                          style={{ color: "red" }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                <ConfirmDialog
                  open={openDialog}
                  onClose={() => setOpenDialog(false)}
                  onConfirm={confirmDelete}
                />


                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Income And Expenses Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
          </TableContainer>
        </div>
        <nav style={{ flexShrink: 0 }}>
          <ul className="pagination justify-content-center">
            <li
              className={`page-item ${page === 1 && "disabled"
                }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setPage((p) => Math.max(p - 1, 1))
                }
              >
                Previous
              </button>
            </li>

            {Array.from(
              { length: Math.min(5, pageCount) },
              (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${page === i + 1 && "active"
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              )
            )}

            {pageCount > 5 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => setPage(pageCount)}
                  >
                    {pageCount}
                  </button>
                </li>
              </>
            )}

            <li
              className={`page-item ${page === pageCount && "disabled"
                }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setPage((p) => Math.min(p + 1, pageCount))
                }
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </Paper>
    </div>
  );
};

export default IncomeAndExpensesList;

